var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ProductionDesignInitiativeReview.jinja');
require('./ProductionDesignInitiativeReview.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        this.$('.ProductionDesignInitiativeReview-uploads .ProductionDesignInitiativeReview-value a').each(function (ind, item) {
             //extract filename from full path
            var filename = $(this).attr('data-name');

            if (filename) {
                filename = filename.split('/');
                $(this).text(filename[filename.length - 1]);
            }
        });

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionDesignInitiativeReview/ProductionDesignInitiativeReview.js
// module id = 243
// module chunks = 0